export const T = {
  en_GB: {
    copy: "Copy",
    title: "MCP Server",
    description: "Connect Claude Desktop or Claude Code CLI to Quantfolio Platform via OAuth",
    endpoint: "Endpoint",
  },
  nb_NO: {
    copy: "Kopier",
    title: "MCP-server",
    description: "Koble Claude Desktop eller Claude Code CLI til Quantfolio Platform via OAuth",
    endpoint: "Endepunkt",
  },
} as const;
